module.exports = __webpack_public_path__ + "img/part_6_2.f0c5fc0b.png";